import React, { useEffect, useState } from "react";
import ButtonActionDetailGroup from "../../../common/ButtonActionDetailGroup";
import { PaymentRowLayout } from "./PaymentRowLayout";
import { TransactionService } from "../../../../services/TransactionService";
import PaymentGeneralInformation from "./PaymentGeneralInformation";
import PaymentPasses from "./PaymentPasses";
import PaymentVouchers from "./PaymentVouchers";
import PaymentEVouchers from "./PaymentEVouchers";
import { useTransactionChargedStatus } from "../../../../hooks/useTransactionChargedStatus";

const PaymentInformation = (props) => {
  const {
    transaction,
    paymentCredit,
    paymentEVouchers,
    onChargedStatusChanged,
    eVouchers,
  } = props;

  const [paymentPasses, setPaymentPasses] = useState([]);
  const { isViewableChargedStatus, viewChargedStatus } =
    useTransactionChargedStatus();

  useEffect(() => {
    new TransactionService()
      .getPaymentPasses(transaction.id)
      .then((response) => {
        setPaymentPasses(response);
      });
  }, [transaction.id]);

  const getChargeStatus = async () => {
    const isCharged = await viewChargedStatus(transaction.id);
    onChargedStatusChanged(isCharged);
  };

  return (
    <>
      <PaymentRowLayout first="Payment method:" third="Payment Amount" />
      <PaymentGeneralInformation
        transaction={transaction}
        paymentPasses={paymentPasses}
        paymentCredit={paymentCredit}
      />
      <PaymentVouchers transactionId={transaction.id} />
      <PaymentPasses
        transaction={transaction}
        data={paymentPasses}
        paymentCredit={paymentCredit}
      />
      <PaymentEVouchers data={paymentEVouchers} eVouchers={eVouchers} />
      {isViewableChargedStatus(transaction) && (
        <ButtonActionDetailGroup>
          <ButtonActionDetailGroup.Item
            className="btn btn-primary"
            onClick={getChargeStatus}
          >
            View Charged Status
          </ButtonActionDetailGroup.Item>
        </ButtonActionDetailGroup>
      )}
    </>
  );
};

export default PaymentInformation;
